import type { ICatalog, IModuleDefinition, IRecordTypeResponse } from '@platform/core/types';
import type { HttpClient } from './HttpClient';

/**
 * Каталог метаданих, визначення модулів і типів записів. З `workspaceId` сервер повертає визначення, злите з налаштуваннями цього простору
 * (ADR-023: опубліковане визначення + накладка простору), без нього — опубліковане.
 */
export class MetadataDao {
  constructor(private readonly http: HttpClient) {}

  catalog(workspaceId?: string): Promise<ICatalog> { return this.http.get('/meta/catalog', { workspaceId }); }
  module(key: string, workspaceId?: string): Promise<IModuleDefinition> { return this.http.get(`/meta/modules/${encodeURIComponent(key)}`, { workspaceId }); }
  recordType(key: string, workspaceId?: string): Promise<IRecordTypeResponse> { return this.http.get(`/meta/record-types/${encodeURIComponent(key)}`, { workspaceId }); }
}
